import React from 'react';
import { Link } from 'react-router-dom';

const FinanceNavbar = () => {
    return (
        <>
            <li className="nav-item">
                <a className="nav-link menu-link" href="#invoiceInf" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="invoiceInf">
                    <i className="ri-rocket-line"></i>
                    <span data-key="t-clients">Influencer Invoices</span>
                </a>
                <div className="collapse menu-dropdown" id="invoiceInf">
                    <ul className="nav nav-sm flex-column">
                        <li className="nav-item">
                            <Link to="/pending-invoices" className="nav-link" data-key="t-analytics">Pending Invoices</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/completed-invoices" className="nav-link" data-key="t-analytics">Completed Invoices</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/cencelled-invoices" className="nav-link" data-key="t-analytics">Cancelled Invoices</Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/all-invoices" className="nav-link" data-key="t-analytics">All Invoices</Link>
                        </li>
                    </ul>
                </div>
            </li>
        </>
    );
}

export default FinanceNavbar;
